import { exception, exceptionWithMultipleContext } from "../exception";
const kind = "ValidationException";
export const validationException = exception(kind);
export const validationExceptionMany = exceptionWithMultipleContext(kind);

